<template>
  <div class="footer pt-2">
    <div class="container">
      <div class="row">
        <div v-if="useLocales" class="col-4 order-2">
          <LocaleSelect />
        </div>
        <div :class="{'col-8 order-1': useLocales}">
          <h4>{{ $t('contactUs') }}</h4>
          <ul>
            <li>
              <a :href="'mailto:' + $store.getters.getStudyEmail">{{ $store.getters.getStudyEmail }}</a>
              <span v-if="$store.getters.getStudyPhoneNumber">
                {{ $t('or') }} <a :href="'tel:' + $store.getters.getStudyPhoneNumber">{{ $store.getters.getStudyPhoneNumber }}</a>
              </span>
            </li>
            <li>&nbsp;</li>
            <li><em>{{ $t('poweredBy') }} Way to Health</em></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import LocaleSelect from './LocaleSelect.vue';

  export default {
    name: "Footer",
    components: {
      LocaleSelect
    },
    computed: {
      ...mapState(['useLocales','locales']),
    }
  }
</script>

<style scoped>

  .footer {
    flex-shrink: 0;
    z-index: 1030;
    min-height: auto;
  }
</style>
